module.exports = __webpack_public_path__ + "files/396511e40ef48c5c1c54ab5576f40f25.png";